import React from 'react';

import '../index.css'


function Footer(props) {


    return <div className='footer'><a rel="license" href="http://creativecommons.org/licenses/by-nc-sa/4.0/"><img alt="知识共享许可协议" src="https://i.creativecommons.org/l/by-nc-sa/4.0/80x15.png" /></a></div>


}

export default Footer;